import { updateMockAgent as e, withDelay as t } from "./AgentConfigurationResource.mocks.js";
import { shouldMockAgentConfiguration as n } from "./ShouldMockAgentConfiguration.js";
import { API as r, Resource as i } from "@coveo/platform-client";
// src/resources/agent-configuration/AgentConfigurationResource.ts
var a = 2e3, o = class o extends i {
	static {
		this.baseUrl = `/api/preview/organizations/${r.orgPlaceholder}/agents`;
	}
	list(e) {
		return this.api.get(this.buildPath(o.baseUrl, e));
	}
	get(e) {
		return this.api.get(`${o.baseUrl}/${e}`);
	}
	create(e) {
		return this.api.post(o.baseUrl, e);
	}
	update(r, i, s) {
		if (n(this.api.organizationId, s?.isMocking)) {
			let n = e(r, i);
			return n ? t(n, a) : Promise.reject(/* @__PURE__ */ Error(`Agent with ID ${r} not found`));
		}
		return this.api.patch(`${o.baseUrl}/${r}`, i);
	}
	delete(e) {
		return this.api.delete(`${o.baseUrl}/${e}`);
	}
};
export { o as AgentConfigurationResource };

//# sourceMappingURL=AgentConfigurationResource.js.map